import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { TextLink, TextLinkCaret } from "@vds/buttons";
import { RadioBox } from "@vds/radio-boxes";
import { Tabs, Tab } from "@vds/tabs";
import { Body, Micro, Title } from "@vds/typography";
import { MarginSpacerS } from "common/components/styleTag";
import { formatPriceString } from "utils/commonUtils";
import DeviceUnlockModal from "../modals/DeviceUnlockModal";
import PDPContext from "../pdpContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Icon } from "@vds/icons";
import { useGlobalData } from "hooks";
import { Notification } from "@vds/notifications";

const StorageAndPrice = ({ isStickyButton, handleAutoScroll = () => {}, scrollItemId = "", ...props }) => {
  const navigate = useNavigate();
  const { metaInformation } = useGlobalData();
  const showCreditFirstEntryPoint = metaInformation?.enableCreditFirstFlow || false
  const { t } = useTranslation(["pdp", "credit-first"]);
  const limit = "$2,000";
  const price = "$499.99";
  const downPayment = "$100.00";
  const {
    selectedSku: { selectedSku, setSelectedSku },
    selectedPayment: { selectedPayment, setSelectedPayment },
    addToAllLines: { addToAllLines, setAddToAllLines },
    memoryOptions,
    isOneTalk,
    isLTEOrCband,
    tradeInValueInfo: { tradeInValueInfo },
    reinitiateFlow
  } = React.useContext(PDPContext);
  const creditData = useSelector((state) => state.CreditFirstSlice)
  const devicePayments =
    selectedSku?.pricingDetails?.devicePayments &&
    selectedSku?.pricingDetails?.devicePayments[0];
    // console.log("Device payments", devicePayments)
  const fullRetailPricing = selectedSku?.pricingDetails?.zeroYear;
  const twoYearPricing = selectedSku?.pricingDetails?.twoYear;
  const globalData = useSelector((state) => state.GlobalData);
  const [tabIndex, setTabIndex] = useState(undefined);
  const [notifyChange, setNotifyChange] = useState(false);
  const [isDeviceUnlock, setIsDeviceUnlock] = useState(false);
  const location = useLocation();
  const isMobile = useMediaQuery({
    query: "(max-width: 725px)",
  });
  const enableTXOfferChange = t("device-pdp.enable_TX_Monthly_Offer" , {ns: "pdp"}) ;
  const twoYearPlansFirstMessage = t("device-pdp.twoYearContract-plansFirstMessaging" , {ns: "pdp"}) ;

  const PriceBoxContainer = styled.div`
    width: 100%;
    @media screen and (min-width: 230px) and (max-width: 767px) {
      margin-bottom: 1rem;
    }
    .strikethrough {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.5px;
      text-align: left;
    }
  ${({isStickyButton}) => isStickyButton && 
     `z-index:: 0 !important;
     position:sticky `
    }
    ${!isMobile &&
    `display:flex !important;
    flex-wrap:wrap;    
    `}
    margin-top: 1rem;
  `;

  const AmountTitle = styled.div`
    font-size: 16px;
    font-weight: ${isOneTalk ? "700" : "400"};
    line-height: 20px;
    letter-spacing: 0.5px;
    text-align: left;
  `;

  const CustomTab = styled(Tab)`
    margin: 0 24px 0 0;
  `;
  const isPriceBox = memoryOptions?.length == 1;
  const isPriceBoxLength4 = memoryOptions?.length > 4;
  const AutoScroll = styled.div`
  height: auto;
    flex: ${!isMobile
      ? isPriceBoxLength4
        ? "0 0 22%"
        : isPriceBox
          ? "0.52"
          : "1"
      : " 2 1 auto"};
    max-width: ${!isMobile ? (isPriceBox ? "292px" : "100%") : " 100%"};
    margin: ${!isMobile ? "5px 12px 17px 0" : "5px 1px 12px 0"};
    ${isMobile && `width:100%`}
  `;
  const PriceBox = styled(RadioBox)`
  `;

  const getPricingDetails = (pricingDetails) => {
    if (selectedPayment === "fullpayment") {
      return pricingDetails?.zeroYear;
    } else if (selectedPayment === "twoyears") {
      return pricingDetails?.twoYear;
    } else {
      return (
        pricingDetails?.devicePayments?.length &&
        pricingDetails?.devicePayments[0]
      );
    }
  };
let noOfTabs = (devicePayments && twoYearPricing?.contractTerm && fullRetailPricing)  ? 3 : ((devicePayments && fullRetailPricing) ||(twoYearPricing?.contractTerm && fullRetailPricing)) ? 2 : 1;
  const onTabChangeFunc = (_event, index) => {
    if (props?.showTradeInToggle === "Y" && props?.tradeInToggle && index === 0) {
      props?.setTradeInToggle(true);
    } else {
      props?.setTradeInToggle(false);
    }
    setTabIndex(index);
    let paymentType ="fullpayment"
    if(noOfTabs==3){
      index === 0 ? paymentType="monthly" :index ===1 ? paymentType="twoyears" : paymentType="fullpayment"
    }
    if(noOfTabs==2){
      index === 0 ? paymentType=(devicePayments? "monthly" : "twoyears"): paymentType="fullpayment"
    }
    if(noOfTabs==1){
      paymentType="fullpayment"
    }
    setSelectedPayment(paymentType);


  };

  useEffect(()=>{
    if(String(props?.oldPriceType).includes("MONTH_TO_MONTH") && (String(selectedPayment).includes("twoyears") || String(selectedPayment).includes("fullpayment") )){
        setNotifyChange(true);
    }else{
      setNotifyChange(false);
    }
  },[selectedPayment])

  useEffect(() => {
    if (
      (props?.editPackageDeviceSku &&
        selectedSku &&
        props.editPackageDeviceSku !== selectedSku.sku) ||
      !props.editPackageDeviceSku
    ) {
      if (selectedSku && tabIndex === undefined) {
        onTabChangeFunc(null, 0);
      }
    } else if (
      props?.editPackageDeviceSku &&
      selectedSku &&
      props.editPackageDeviceSku === selectedSku.sku
    ) {
      let index = String(selectedPayment).includes("fullpayment") && !isOneTalk 
        ? 2 
        : String(selectedPayment).includes("fullpayment") && isOneTalk 
        ? 1 
        : String(selectedPayment).includes("twoyears")
          ? 1
          : 0;
      setTabIndex(index);
    }
   
  }, [selectedSku]);

  const getFormattedPrice = (pricingDetails, hasTradeInPromo, tradeInPromoPrice,selectedPayment) => {
    let price = null;
    if (props?.showTradeInToggle === "Y" && props?.tradeInToggle && selectedPayment==="monthly") {
      price = pricingDetails?.tradeInOfferDetails?.discountAmount ? pricingDetails?.tradeInOfferDetails?.discountAmount
        : pricingDetails?.offerDetails?.discountAmount?  pricingDetails?.offerDetails?.discountAmount : pricingDetails?.finalPrice
    } else if (hasTradeInPromo && tradeInPromoPrice > -1) {
      price = tradeInPromoPrice;
    } else if (pricingDetails?.offerDetails?.discountAmount) {
      price = pricingDetails?.offerDetails?.discountAmount;
    } else {
     price = pricingDetails?.finalPrice
    }
    return formatPriceString(price)
  }

  return (
    <SectionContainer isStickyButton={isStickyButton}>
      <Tabs
        orientation="horizontal"
        indicatorPosition="bottom"
        linePosition="bottom"
        onTabChange={onTabChangeFunc}
        selectedIndex={tabIndex}
        bold={false}
      >
        <CustomTab
          label={`${devicePayments?.nofInstallements} months`}
          hide={!devicePayments}
        />

        <CustomTab
          label={
            twoYearPricing?.contractTerm &&
            t("device-pdp.twoyearscontract", { ns: "pdp" })
          }
          hide={(props?.isPlanFirstFlow && !isLTEOrCband) 
             || !twoYearPricing?.contractTerm
          }
        />

        <CustomTab label="Full retail price" hide={!fullRetailPricing} />
      </Tabs>
      <MarginSpacerS/>
     {enableTXOfferChange == "Y" && props?.isOfferAppliedForPlans && props?.isfromShoppingCart && props?.isBillingState_TX && props?.isProOrPlusPlan && props?.isSmartPhone && notifyChange && <Body size="small"> {t("device-pdp.notify-change", { ns: "pdp" })}</Body>}
     {globalData.flow === 'plans-first' && tabIndex == 1 && <PlansFirst2YearText>{twoYearPlansFirstMessage}</PlansFirst2YearText>}
     {selectedPayment === "monthly" && showCreditFirstEntryPoint && !creditData?.creditFirstResponse?.data?.businessInfo?.creditApplicationNum && 
     <div className="credit-first-pdp-entry-container">
        <div className="credit-first-icon-container">
          <Icon name="wallet" size="XLarge" color="#EE0000"/>
        </div>
        <div className="credit-first-text-button-container">
          <Title size="small">Buy now and pay over 36 months</Title>
          <TextLinkCaret 
            surface="light"  
            iconPosition="right"
            onClick={() => navigate("/shop/credit-first")}>
            See if you qualify
          </TextLinkCaret>
        </div>
      </div>}
     {selectedPayment === "monthly" && showCreditFirstEntryPoint && devicePayments?.spendingLimit === "WITH_IN_SPENDING_LIMIT" && 
      <Notification
        type="success"
        title={t("pdp-banner.informational.has-not-hit-limit.title", { limit: devicePayments?.profileSpendingLimit || limit, ns: "credit-first", returnObjects: true})}
        subtitle={t("pdp-banner.informational.has-not-hit-limit.subtitle", { price: devicePayments?.frp || price, ns: "credit-first", returnObjects: true })}
        surface="light"
        disableAnimation={false}
        fullBleed={false}
        hideCloseButton={true}
        disableFocus={true}
      />
    }
    {selectedPayment === "monthly" && showCreditFirstEntryPoint && devicePayments?.spendingLimit === "WILL_HIT_SPENDING_LIMIT" && 
      <Notification
        type="warning"
        title={t("pdp-banner.warning.will-hit-limit.title", { limit: devicePayments?.profileSpendingLimit || limit, ns: "credit-first", returnObjects: true })}
        subtitle={t("pdp-banner.warning.will-hit-limit.subtitle", { price: devicePayments?.frp || price, downPayment: devicePayments?.downPayment || downPayment, ns: "credit-first", returnObjects: true })}
        surface="light"
        disableAnimation={false}
        fullBleed={false}
        hideCloseButton={true}
        disableFocus={true}
      />
    }
    {selectedPayment === "monthly" && showCreditFirstEntryPoint && devicePayments?.spendingLimit === "AlREADY_HIT_SPENDING_LIMIT" && 
      <Notification
        type="warning"
        title={t("pdp-banner.warning.has-hit-limit.title", { limit: devicePayments?.profileSpendingLimit || limit, ns: "credit-first", returnObjects: true })}
        subtitle={t("pdp-banner.warning.has-hit-limit.subtitle", { downPayment: devicePayments?.downPayment || downPayment, ns: "credit-first", returnObjects: true })}
        surface="light"
        disableAnimation={false}
        fullBleed={false}
        hideCloseButton={true}
        disableFocus={true}
      />
    }
    {selectedPayment === "monthly" && showCreditFirstEntryPoint && devicePayments?.spendingLimit === "UPDATE_QTY_HIT_SPENDING_LIMIT" && 
      <Notification
        type="warning"
        title={t("pdp-banner.warning.updated-quantity.title", { limit: devicePayments?.profileSpendingLimit || limit, ns: "credit-first", returnObjects: true })}
        subtitle={t("pdp-banner.warning.updated-quantity.subtitle", { price: devicePayments?.frp || price, downPayment: devicePayments?.downPayment || downPayment, ns: "credit-first", returnObjects: true })}
        surface="light"
        disableAnimation={false}
        fullBleed={false}
        hideCloseButton={true}
        disableFocus={true}
      />
    }
    {selectedPayment === "monthly" && showCreditFirstEntryPoint && devicePayments?.spendingLimit === "DPP_NOT_APPROVED_SSN_NOT_ENTERED" && 
      <Notification
        type="warning"
        title={t("pdp-banner.warning.not-qualified.title", { ns: "credit-first", returnObjects: true })}
        subtitle={t("pdp-banner.warning.not-qualified.subtitle", { ns: "credit-first", returnObjects: true })}
        surface="light"
        disableAnimation={false}
        fullBleed={false}
        hideCloseButton={true}
        disableFocus={true}
      />
    }
     <PriceBoxContainer isStickyButton={isStickyButton}>
        {memoryOptions.map((sku) => {
          if (sku?.pricingDetails !== null && sku?.pricingDetails) {
            const pricingDetails = getPricingDetails(sku?.pricingDetails);
            const hasTradeInPromo =
              pricingDetails?.promoDetails?.length &&
              pricingDetails.promoDetails.find(
                (i) => i?.promoType === "TRADEIN_PER_MONTH"
              );
            const tradeInPromoPrice =
              hasTradeInPromo &&
              tradeInValueInfo?.pricing?.find(
                (i) =>
                  i?.sku === sku?.sku &&
                  i?.noOfInstallments === pricingDetails?.nofInstallements
              )?.price;
            if (selectedSku?.sku === sku?.sku &&
              hasTradeInPromo &&
              props?.tradeInForSubtitle &&
              typeof props.tradeInForSubtitle === "function" &&
              tradeInPromoPrice > -1
            ) {
              props.tradeInForSubtitle(tradeInPromoPrice);
            }
            return (
              <AutoScroll onClick={() => handleAutoScroll(scrollItemId)}>
                <PriceBox
                  key={sku?.sku}
                  selected={selectedSku?.sku === sku?.sku}
                  onChange={() =>{
                    setSelectedSku(sku)
                    // reinitiateFlow()
                  }}
                  disabled={sku?.outOfStock}
                  outOfStock={sku?.outOfStock}
                  data-track={`${sku?.capacity} ${getFormattedPrice(pricingDetails, hasTradeInPromo, tradeInPromoPrice,selectedPayment)}${selectedPayment === "fullpayment" || selectedPayment === "twoyears" ? "" : "/mo"}`}
                  children={
                    <>
                      <Capcitytitle data-track={sku?.capacity}>
                        {sku?.capacity}
                      </Capcitytitle>
                      <AmountTitle bold={isOneTalk} size="small">{`${getFormattedPrice(pricingDetails, hasTradeInPromo, tradeInPromoPrice,selectedPayment)}${selectedPayment === "fullpayment" || selectedPayment === "twoyears" ? "" : "/mo"}`}</AmountTitle>
  
                      {(getFormattedPrice(pricingDetails, hasTradeInPromo, tradeInPromoPrice,selectedPayment) !== formatPriceString(pricingDetails?.finalPrice)) &&!!((props?.showTradeInToggle === "Y" && props?.tradeInToggle && selectedPayment==="monthly" && pricingDetails?.tradeInOfferDetails?.discountAmount >= 0) 
                      || pricingDetails?.offerDetails?.discountAmount >= 0 || hasTradeInPromo?.discAmount > 0 || tradeInPromoPrice > -1) && !props?.isBogo && (
                        <Micro color="">
                          <span className="strikethrough">
                            {`${formatPriceString(pricingDetails?.finalPrice)}${selectedPayment === "fullpayment" ||
                              selectedPayment === "twoyears"
                              ? ""
                              : "/mo"
                              }`}
                          </span>
                        </Micro>
                      )}
                    </>
                  }
                />
              </AutoScroll>
            );
          } else return <></>
        })}
      </PriceBoxContainer>
      <Priceinfotext>
        <Body>
          {selectedPayment == "monthly" &&
            <>Monthly payments shown are for customers who qualify to pay $
              {devicePayments?.minimumPlanAccessFee} down, {!isMobile && <br />}
              <span>
                {" "}
                {`${formatPriceString(props.tradinPrice !== null && props.tradinPrice > -1 ? props.tradinPrice : devicePayments?.offerDetails?.discountAmount ?? devicePayments?.finalPrice)}/mo`}
              </span>{" "}
              for {devicePayments?.nofInstallements} months; {isMobile && <br />}0% APR. Retail price: $
              {fullRetailPricing?.finalPrice}.
            </>
          }
          {selectedPayment == "twoyears" &&
            <span>One time payment and 2-year service agreement required.</span>
          }
          {selectedPayment == "fullpayment" &&
            ""
          }

        </Body>
      </Priceinfotext>
      {selectedPayment == "monthly" && (
        <Links>
          {!location?.pathname?.includes("mobile-hotspots") && 
           (!props?.enableDeviceLock && props?.isSmartPhone ) && (
            <TextLink
              className="device-info"
              onClick={() => setIsDeviceUnlock(true)}
              data-track={t("device-pdp.deviceUnlockingPolicy", { ns: "pdp" })}
            >
              {t("device-pdp.deviceUnlockingPolicy", { ns: "pdp" })}
            </TextLink>
          )}
        </Links>
      )}
      {isDeviceUnlock && (
        <DeviceUnlockModal
          opened={isDeviceUnlock}
          onOpenedChange={setIsDeviceUnlock}
        />
      )}
      <MarginSpacerS />
    </SectionContainer>
  );
};

const PlansFirst2YearText = styled.div`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

const Priceinfotext = styled.div`
  font-family: Verizon-NHG-eTX;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
`;

const SectionContainer = styled.div`
  .device-info {
    display: inline-block;
    margin-bottom: -1rem !important;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 0.3rem;
  }
     ${({isStickyButton}) => isStickyButton && 
     `z-index:: 0 !important;
     position:sticky `
    }
`;

const Links = styled.div`
  padding-top: 0.5rem;
  display: block;
  gap: 0.75rem;
  font-family: Verizon-NHG-eTX;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
`;

const Capcitytitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
`;

export default React.memo(StorageAndPrice);
